export const RESET = 'EXSBITEMBRAND_UPDATE_RESET'
export const SET_ERROR = 'EXSBITEMBRAND_UPDATE_SET_ERROR'
export const SET_RETRIEVED = 'EXSBITEMBRAND_UPDATE_SET_RETRIEVED'
export const SET_UPDATED = 'EXSBITEMBRAND_UPDATE_SET_UPDATED'
export const SET_VIOLATIONS = 'EXSBITEMBRAND_UPDATE_SET_VIOLATIONS'
export const TOGGLE_LOADING = 'EXSBITEMBRAND_UPDATE_TOGGLE_LOADING'
export const UPDATE_RETRIEVED = 'EXSBITEMBRAND_UPDATE_UPDATE_RETRIEVED'
